import { useEffect, useRef, useState } from "react";
import { BiSolidEdit } from "react-icons/bi";
import { FaWhatsapp } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import styles from "./css/leadMenu.module.css";


export default function LeadMenu({view, data, refreshList, openEditor, close}) {

  const [lead, setLead] = useState([]);

  const wppLink = useRef(null);

  useEffect(() => {
    if(data){
      setLead(data)

      if(data.phone){
        // Cria link para contato pelo whatsapp
        const formatted = data.phone.replace('(', '').replace(')', '').replaceAll(' ', '').replace('-', '');
        const link = `https://wa.me/55${formatted}`;
  
        wppLink.current = link;
      }

    }
  }, [data])



  // SCREEN =============================================>

  return view && (
    <div className={styles.openCompanyArea}>

      <div className={styles.openCompanyOverflow} />

      <div className={styles.openCompanyBox}> 

        <div className={styles.headerCompanyBox}>
          <div className={styles.headerCompanyBox} style={{justifyContent: 'flex-start'}}>
            <button className={styles.editCompanyDataButton} onClick={() => openEditor()}>
              <BiSolidEdit size={20}/>
            </button>

            <p className={styles.companyName}>{lead.name}</p>
          </div>



          <button className={styles.closeButton} onClick={() => close()}>
            <IoIosCloseCircle size={30} color="#fff" />
          </button>
        </div>



        <div className={styles.informationsArea}>
          {/* <======================== DADOS FISCAIS ========================> */}

          <div className={styles.titleArea}>
            <p className={styles.titleInformations} style={{ margin: 0 }}>Dados do lead:</p>
          </div>

          <p className={styles.textInformations}>
            <b>Nome:</b>{" "}
            {lead.name}
          </p>

          <p className={styles.textInformations}>
            <b>Email:</b> {lead.email}
          </p>

          <div className={styles.rowArea}>
            <p className={styles.textInformations}>
              <b>Telefone:</b> {lead.phone}
            </p>

            <a href={wppLink.current} target='_blank'>
              <button className={styles.whatsappButton}>
                <FaWhatsapp color='#fff' size={20}/>

                <span style={{color: '#ffff'}}>Conversar</span>
              </button>
            </a>
          </div>

          <p className={styles.textInformations}>
            <b>CPF:</b> {lead.document ?? 'Sem dados'}
          </p>

          <p className={styles.textInformations}>
            <b>Lead válido:</b> {lead.is_valid ? 'Sim' : 'Não'}
          </p>

          <p className={styles.textInformations}>
            <b>Convertido:</b> {lead.active ? 'Sim' : 'Não'}
          </p>

          <p className={styles.textInformations}>
            <b>Registrado em:</b> {new Date(lead.created_at).toLocaleString('pt-BR')}
          </p>

        </div>
      </div>

    </div>
  );
}
